/* src/app/shared/strava-table/strava-table.component.scss */
.bar {
  padding: 3vw;
}
.leftCol {
  padding-left: 1vw;
  text-align: left;
}
.rightCol {
  padding-right: 1vw !important;
  text-align: right;
}
.topRow {
  font-size: small;
  font-weight: bold;
  margin-bottom: 2vw;
}
.topRow > ion-col:not(:first-child):not(:last-child) {
  border-bottom: 1px solid lightgray;
}
.topRow > ion-col {
  padding-bottom: 1vw !important;
}
.tableRow:first-child {
  padding-top: 3vw;
}
.tableRow {
  padding-top: 1vw;
}
.midCol {
  text-align: center;
}
/*# sourceMappingURL=strava-table.component.css.map */
